import React, { Component } from 'react';
import { Link } from "react-router-dom";

function openFuncation() {
    var element = document.getElementById("navmobile");
    element.classList.add("show-menu");
}
function closeFuncation() {
    var element = document.getElementById("navmobile");
    element.classList.remove("show-menu");
}

export default class Navbar extends Component {
    constructor() {
        super();
        this.state = {
            active: 'home'
        };
        this._handleClick = this._handleClick.bind(this);
    }

    _handleClick(e) {
        this.setState({
            active: e.target.innerHTML
        });
    }

    render() {
        let homeStyle, aboutStyle, servicesStyle, portfolioStyle, certificateStyle, contactStyle, clientsStyle;

        if (this.state.active === 'Home') {
            homeStyle = { color: '#be3838' };
            aboutStyle = servicesStyle = portfolioStyle = certificateStyle = contactStyle = clientsStyle = {};
        } else if (this.state.active === 'About Me') {
            aboutStyle = { color: '#be3838' };
            homeStyle = servicesStyle = portfolioStyle = certificateStyle = contactStyle = clientsStyle = {};
        } else if (this.state.active === 'Services') {
            servicesStyle = { color: '#be3838' };
            homeStyle = aboutStyle = portfolioStyle = certificateStyle = contactStyle = clientsStyle = {};
        } else if (this.state.active === 'Portfolio') {
            portfolioStyle = { color: '#be3838' };
            homeStyle = aboutStyle = servicesStyle = certificateStyle = contactStyle = clientsStyle = {};
        } else if (this.state.active === 'My Clients') {
            clientsStyle = { color: '#be3838' };
            homeStyle = aboutStyle = servicesStyle = portfolioStyle = certificateStyle = contactStyle = {};
        } else if (this.state.active === 'Certificate') {
            certificateStyle = { color: '#be3838' };
            homeStyle = aboutStyle = servicesStyle = portfolioStyle = contactStyle = clientsStyle = {};
        } else if (this.state.active === 'Contact') {
            contactStyle = { color: '#be3838' };
            homeStyle = aboutStyle = servicesStyle = portfolioStyle = certificateStyle = clientsStyle = {};
        } else {
            homeStyle = { color: '#be3838' };
            aboutStyle = servicesStyle = portfolioStyle = certificateStyle = contactStyle = clientsStyle = {};
        }

        return (
            <>
                <nav id="navbar" className="navbar">
                    <i className="bi bi-list mobile-nav-toggle" onClick={openFuncation}></i>
                    <ul className="navmobile" id="navmobile" onClick={closeFuncation}>
                        <i className="bi bi-x-lg closebtn" onClick={closeFuncation}></i>
                        <li><Link className="nav-link scrollto active" style={homeStyle} onClick={this._handleClick} to="/">Home</Link></li>
                        <li><Link className="nav-link scrollto" style={aboutStyle} onClick={this._handleClick} to="about-me">About Me</Link></li>
                        <li><Link className="nav-link scrollto" style={servicesStyle} onClick={this._handleClick} to="services">Services</Link></li>
                        <li><Link className="nav-link scrollto" style={portfolioStyle} onClick={this._handleClick} to="portfolios">Portfolio</Link></li>
                        <li><Link className="nav-link scrollto" style={clientsStyle} onClick={this._handleClick} to="my-clients">My Clients</Link></li>
                        <li><Link style={certificateStyle} onClick={this._handleClick} to="certificate">Certificate</Link></li>
                        <li><Link className="nav-link scrollto" style={contactStyle} onClick={this._handleClick} to="contact">Contact</Link></li>
                        <li><a className="getstarted scrollto" href="tel:+917838704822" target="_blank" rel="noopener noreferrer"><i className="bi bi-earbuds"></i>&nbsp; Call Me</a></li>
                    </ul>
                </nav>
            </>
        );
    }
}
